import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
export default new Router({
  routes: [
    {
      path: "/home",
      name: "home",
      meta: {
        title: "医方教育"
      },
      component: () => import("@/view/index/index.vue")
    },
    //视听专区AudioVisualZone
    {
      path: "/AudioVisualZone",
      name: "AudioVisualZone",
      meta: {
        title: "免费试听"
      },
      component: () => import("@/view/AudioVisualZone/AudioVisualZone.vue")
    },
    {
      path: "/Application",
      name: "Application",
      meta: {
        title: "报名通道"
      },
      component: () => import("@/view/Application/index.vue")
    },
    {
      path: "/video_detail",
      name: "video_detail",
      meta: {
        title: "视频详情"
      },
      component: () => import("@/view/AudioVisualZone/video_detail.vue")
    },
    // {
    //   path: "/video_sk",
    //   name: "video_sk",
    //   meta: {
    //     title: "视频详情"
    //   },
    //   component: () => import("@/view/AudioVisualZone/video_sk.vue")
    // },
    //支付页面
    {
      path: "/pay",
      name: "pay",
      meta: {
        title: "用户支付"
      },
      component: () => import("@/view/pay.vue")
    },
    {
      path: "/Question_bank",
      name: "Question_bank",
      meta: {
        title: "医方题库"
      },
      component: () => import("@/view/Question_bank/Question_bank.vue")
    },
    {
      path: "/mine_wrong",
      name: "mine_wrong",
      meta: {
        title: "我的错题"
      },
      component: () => import("@/view/Question_bank/mine_wrong.vue")
    },
    {
      path: "/mine_wrong2",
      name: "mine_wrong2",
      meta: {
        title: "我的收藏"
      },
      component: () => import("@/view/Question_bank/mine_wrong.vue")
    },
    {
      path: "/mine_wrong3",
      name: "mine_wrong3",
      meta: {
        title: "我的笔记"
      },
      component: () => import("@/view/Question_bank/mine_wrong.vue")
    },
    {
      path: "/mine_wrong4",
      name: "mine_wrong4",
      meta: {
        title: "章节练习"
      },
      component: () => import("@/view/Question_bank/mine_wrong.vue")
    },
    {
      path: "/node_list",
      name: "node_list",
      meta: {
        title: "笔记列表"
      },
      component: () => import("@/view/Question_bank/node_list.vue")
    },
    {
      path: "/paper_review",
      name: "paper_review",
      meta: {
        title: "试卷回顾"
      },
      component: () => import("@/view/Question_bank/paper_review.vue")
    },
    {
      path: "/examination_outcome",
      name: "examination_outcome",
      meta: {
        title: "考试结果"
      },
      component: () => import("@/view/Question_bank/examination_outcome.vue")
    },
    {
      path: "/examination_outcome2",
      name: "examination_outcome2",
      meta: {
        title: "仿真结果"
      },
      component: () => import("@/view/Question_bank/examination_outcome2.vue")
    },
    {
      path: "/disposition_paper",
      name: "disposition_paper",
      meta: {
        title: "配置试卷"
      },
      component: () => import("@/view/Question_bank/disposition_paper.vue")
    },
    {
      path: "/history_recording",
      name: "history_recording",
      meta: {
        title: "历史记录"
      },
      component: () => import("@/view/Question_bank/history_recording.vue")
    },
    {
      path: "/chapter_practice",
      name: "chapter_practice",
      meta: {
        title: "章节练习"
      },
      component: () => import("@/view/Question_bank/chapter_practice.vue")
    },
    {
      path: "/emulation",
      name: "emulation",
      meta: {
        title: "仿真试题"
      },
      component: () => import("@/view/Question_bank/emulation.vue")
    },
    {
      path: "/examination",
      name: "examination",
      meta: {
        title: "考试"
      },
      component: () => import("@/view/Question_bank/examination.vue")
    },
    {
      path: "/examination2",
      name: "examination2",
      meta: {
        title: "仿真考试"
      },
      component: () => import("@/view/Question_bank/examination2.vue")
    },
    {
      path: "/wrong_question",
      name: "wrong_question",
      meta: {
        title: "查看错题"
      },
      component: () => import("@/view/Question_bank/wrong_question.vue")
    },
    {
      path: "/questions_echo",
      name: "questions_echo",
      meta: {
        title: "历史记录"
      },
      component: () => import("@/view/Question_bank/questions_echo.vue")
    },
    {
      path: "/SignIn",
      name: "SignIn",
      meta: {
        title: "登录注册"
      },
      component: () => import("@/view/SignIn.vue")
    },
    {
      path: "/detai",
      name: "detai",
      meta: {
        title: "视频详情"
      },
      component: () => import("@/view/AudioVisualZone/detai.vue")
    },
    {
      path: "/retrieve",
      name: "retrieve",
      meta: {
        title: "找回密码"
      },
      component: () => import("@/view/retrieve/index.vue")
    },
    {
      path: "/payindex",
      name: "payindex",
      meta: {
        title: "支付页面"
      },
      component: () => import("@/view/pay/index.vue")
    },
    {
      path: "/curriculum",
      name: "curriculum",
      meta: {
        title: "课程中心"
      },
      component: () => import("@/view/curriculum.vue")
    },
    {
      path: "/pagevue",
      name: "pagevue",
      meta: {
        title: "中间页"
      },
      component: () => import("@/view/pagevue/index.vue")
    },
    {
      path: "/agreement",
      name: "agreement",
      meta: {
        title: "隐私政策"
      },
      component: () => import("@/view/agreement/agreement.vue")
    },
    {
      path: "/ment",
      name: "ment",
      meta: {
        title: "服务条款"
      },
      component: () => import("@/view/agreement/ment.vue")
    },
    // {
    //   path: "/persona",
    //   name: "persona",
    //   meta: {
    //     title: "个人中心"
    //   },
    //   component: () => import("@/view/persona.vue")
    // },
    {
      path: "/personal",
      name: "personal",
      meta: {
        title: "个人中心"
      },
      component: () => import("@/view/personal/personal.vue")
    },
    {
      path: "/WXLogin",
      name: "WXLogin",
      meta: {
        title: "绑定微信"
      },
      component: () => import("@/view/personal/WXLogin.vue")
    },
    {
      path: "/WX",
      name: "WX",
      meta: {
        title: "微信登录"
      },
      component: () => import("@/view/WX.vue")
    },
    {
      path: "/message_detail",
      name: "message_detail",
      meta: {
        title: "消息详情"
      },
      component: () => import("@/view/personal/message_detail.vue")
    },
    {
      path: "/replacement_phone",
      name: "replacement_phone",
      meta: {
        title: "绑定手机"
      },
      component: () => import("@/view/personal/replacement_phone.vue")
    },
    {
      path: "/tearch",
      name: "tearch",
      meta: {
        title: "教师主页"
      },
      component: () => import("@/view/tearch.vue")
    },

    {
      path: "/course_details",
      name: "course_details",
      meta: {
        title: "课程详情"
      },
      component: () => import("@/view/course_details.vue")
    },
    {
      path: "/payment",
      name: "payment",
      meta: {
        title: "支付页面"
      },
      component: () => import("@/view/payment/index.vue")
    },
    {
      path: "/onlineschool",
      name: "onlineschool",
      meta: {
        title: "网校师资",
        Keywords: "网校师资",
        description: "网校师资"
      },
      component: () => import("@/view/onlineschool.vue")
    },
    {
      path: "/coreProducts",
      name: "coreProducts",
      meta: {
        title: "教学资源模块",
        Keywords: "教学资源模块",
        description: "教学资源模块"
      },
      component: () => import("@/view/coreProducts.vue")
    },
    {
      path: "/combination",
      name: "combination",
      meta: {
        title: "虚实结合",
        Keywords: "虚实结合",
        description: "虚实结合"
      },
      component: () => import("@/view/combination.vue")
    },
    {
      path: "/combinationDetails",
      name: "combinationDetails",
      meta: {
        title: "详情",
      },
      component: () => import("@/view/combinationDetails.vue")
    },
    {
      path: "*",
      redirect: "/home"
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js